import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edit\"><path fill=\"#515151\" d=\"M895.855 313.163l-78.107 78.107-185.04-185.041 78.07-78.107c26.508-26.51 53.017 0 53.017 0l132.06 132.022c0 0.001 26.509 26.51 0 53.019zM116.359 907.654l224.337-39.37-185.452-185.452-38.885 224.822z m64.902-249.993l185.066 185.066 423.009-423.009L604.27 234.652l-423.01 423.01z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol